module.exports = __webpack_public_path__ + "media/images/logo_webshop-blue_full@2x-a27b1a421e83ac8dc54a1a34e0fa7e9c.png";